import i18next from 'i18next';

const t = (i18nKey, params) => i18next.t(`userDashboard.layout.breadcrumb.${i18nKey}`, params);

/**
 * Dashboard Routes
 *
 * This file contains the route definitions for the dashboard.
 * Each route object includes the path, the component to render,
 * and optional breadcrumb and other configurations.
 *
 * Breadcrumbs:
 * - The 'breadcrumb' array defines the breadcrumb trail for the route.
 * - Each breadcrumb item can have:
 *   - 'label': The text to display.
 *   - 'url': (Optional) The URL to navigate to when clicked. If not specified, it defaults to the current route's path.
 *   - 'dynamic': (Optional) The name of the route parameter to use for dynamic labels.
 * - If there's already somewhere a 'breadcrumb.url' that matches the url that's in your path, then it will automatically appear.
 * - The breadcrumb also handles repetitions and won't show twice the same label, but it's buggy sometimes it shows the most recent and other times the oldest, idk why.
 * 
 * Dynamic Parameters:
 * - In both 'path' and 'breadcrumb.url', you can include dynamic parameters using ':paramName'.
 * - The values of these parameters are extracted from the URL when the route matches.
 * - In the 'breadcrumb', you can specify 'dynamic' to use a parameter value in the 'label'.
 *
 * Example:
 * {
 *   path: '/dashboard/items/:item_id/edit',
 *   component: ItemEditComponent,
 *   breadcrumb: [
 *     { label: 'Items', url: '/dashboard/items' },
 *     { label: 'Edit Item', dynamic: 'item_id' }
 *   ]
 * }
 * 
 * Result:
 * Items  ---  Edit Item
 * /dashboard/items/:item_id/ --- /dashboard/items/:item_id/ 
 */

const routes = [
    { path: '/dashboard/', component: require('../content/Home').default },

    {
        path: '/dashboard/campaigns', component: require('../content/Campaigns').default, breadcrumb: [
            { label: t('table_campaigns'), url: '/dashboard/campaigns' }
        ],
        showPaginationNavBar: true
    },
    {
        path: '/dashboard/campaigns/create', component: require('../content/Campaigns/CampaignCreate').default, breadcrumb: [
            { label: t('table_campaigns'), url: '/dashboard/campaigns' },
            { label: t('creation') }
        ]
    },
    {
        path: '/dashboard/campaigns/:campaign_id/candidates/edit',
        component: require('../content/Campaigns/CampaignEdit').default,
        breadcrumb: [
            { label: t('modification') }
        ]
    },
    {
        path: '/dashboard/campaigns/:campaign_id/candidates/compare',
        component: require('../content/CandidateDetails/CandidatesCompare').default,
        breadcrumb: [
            { label: 'Comparaison' }
        ]
    },
    {
        path: '/dashboard/campaigns/:campaign_id/candidates',
        component: require('../content/Candidates').default,
        showPaginationNavBar: true,
        breadcrumb: [
            { label: t('table_campaigns'), url: '/dashboard/campaigns' },
            { label: t('table_participants'), dynamic: 'campaign_id' }
        ]
    },
    {
        path: '/dashboard/campaigns/:campaign_id/candidates/:candidate_id',
        component: require('../content/CandidateDetails').default,
        breadcrumb: [
            { label: t('table_participants'), dynamic: 'campaign_id' },
            { label: t('tests'), dynamic: 'candidate_id' }
        ]
    },
    {
        path: '/dashboard/campaigns/:campaign_id/candidates/:candidate_id/:attempt_ref',
        component: require('../content/CandidateDetails/CandidateAttemptDetails').default,
        breadcrumb: [
            { label: t('table_participants'), dynamic: 'campaign_id' },
            { label: t('tests'), dynamic: 'candidate_id' },
            { label: t('rapport'), dynamic: 'attempt_ref' },
        ]
    },

    { path: '/dashboard/candidates/:company_id/:candidate_id/:attempt_ref/generatePdf', component: require('../content/CandidatesPdf').default, breadcrumb: [] },

    { path: '/dashboard/company', component: require('../content/Company').default, breadcrumb: [] },
    { path: '/dashboard/company/create', component: require('../content/CompanyCreate').default, breadcrumb: [] },
    { path: '/dashboard/billing', component: require('../content/Billing').default, breadcrumb: [] },
    { path: '/dashboard/liana', component: require('../content/Liana').default, breadcrumb: [] },
    { path: '/dashboard/preferences', component: require('../content/Preferences').default, breadcrumb: [] }
];


export default routes;